import axios from "./axios";

export const createProjectFile = async (projectId, file, onUploadProgress) => {
  const formData = new FormData();
  formData.append("file", file);
  return await axios.post(`/project/${projectId}/file`, formData, {
    onUploadProgress
  });
};

export const getProject = async (projectId) => {
  return await axios.get(`/project/${projectId}`);
};

export const patchProject = async (projectId, data) => {
  return await axios.patch(`/project/${projectId}`, data);
};

export const deleteProjectFile = async (projectId, fileId) => {
  return await axios.delete(`/project/${projectId}/file/${fileId}`);
};

export const purchaseProject = async (projectId) => {
  return await axios.post(`/project/${projectId}/purchase/`);
};
